import _parseInt from '@babel/runtime-corejs3/core-js/parse-int';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';
import { app, mobile, dom, api } from '@bilibili-maoer/web-utils';
import { isNaN } from 'lodash-es';
import qs from 'qs';
import { MISSEVAN_BILI_PREFIX_URL, MISSEVAN_ANDROID_PACKAGE_NAME } from '../constant.js';
import { biliIsInstall, biliOpenScheme } from './bilibili.js';

var getPId = function getPId() {
  return _parseInt(sessionStorage.getItem('ct-pid'));
};

var getBId = function getBId() {
  return _parseInt(sessionStorage.getItem('ct-bid'));
};

var getId = function getId() {
  var id = getPId();

  if (isNaN(id)) {
    id = getBId();
  }

  return id;
};

function isPidExist() {
  var pId = getPId();
  return !isNaN(pId);
}

var getAppDownloadUrl = function getAppDownloadUrl(channel) {
  var _context;

  var origin = window.location.host === 'maoer.bilibili.com' ? MISSEVAN_BILI_PREFIX_URL : api.MISSEVAN_SITE_MAIN;
  var query = qs.stringify({
    device: mobile.isIOS() ? 1 : 0,
    ct: channel
  }, {
    addQueryPrefix: true
  });
  return _concatInstanceProperty(_context = "".concat(origin, "/app/download")).call(_context, query);
};

function downloadAppViaBiliJSB() {
  var id = getId();
  var APP_DOWNLOAD_LINK = getAppDownloadUrl(id ? "bilibili_".concat(id) : 'bilibili');
  biliOpenScheme(APP_DOWNLOAD_LINK);
}

function downloadApp() {
  var pId = getPId();
  window.location.href = getAppDownloadUrl("bilibili_".concat(pId));
}
function openAppInBiliApp(id, type, opts) {
  var _app$getAppLink = app.getAppLink({
    type: type,
    path: id,
    options: opts
  }),
      url = _app$getAppLink.url;

  if (mobile.isIOS()) {
    // iOS 因底层漏洞可以在广告容器使用 js-bridge，但会出现奇怪的问题
    dom.checkDocumentHidden(downloadAppViaBiliJSB);
    window.location.href = url;
  } else {
    biliIsInstall(MISSEVAN_ANDROID_PACKAGE_NAME, // supportCb
    function (res) {
      if (res !== null && res !== void 0 && res.isInstalled) {
        window.location.href = url;
      } else {
        downloadAppViaBiliJSB();
      }
    }, // unsupportedCb
    function () {
      return biliOpenScheme(url, downloadAppViaBiliJSB);
    });
  }
}

export { downloadApp, isPidExist, openAppInBiliApp };
